// Local translations
export const T = {
  en_GB: {
    editDocumentType: "Edit Document Type",
    addDocumentType: "Add Document Type",
    editDescription: "Update the document type configuration.",
    createDescription: "Create a new document type for products in this collection.",
    name: "Name",
    namePlaceholder: "e.g., KIID, Fact Sheet, Prospectus",
    nameRequired: "Document type name is required",
    morningstarMapping: "Morningstar Mapping (Optional)",
    morningstarMappingDesc:
      "Configure Morningstar Document Library mapping to enable automatic document lookup for products.",
    documentType: "Document Type",
    selectDocumentType: "Select document type...",
    none: "None",
    market: "Market",
    anyMarket: "Any market",
    marketHelpText: 'Leave as "Any" to match first available',
    cancel: "Cancel",
    save: "Save",
    failedToSave: "Failed to save document type",
  },
  nb_NO: {
    editDocumentType: "Rediger dokumenttype",
    addDocumentType: "Legg til dokumenttype",
    editDescription: "Oppdater konfigurasjonen for dokumenttypen.",
    createDescription: "Opprett en ny dokumenttype for produkter i denne samlingen.",
    name: "Navn",
    namePlaceholder: "f.eks. KIID, Faktaark, Prospekt",
    nameRequired: "Navn på dokumenttype er påkrevd",
    morningstarMapping: "Morningstar-kobling (valgfritt)",
    morningstarMappingDesc:
      "Konfigurer Morningstar Document Library-kobling for å aktivere automatisk dokumentoppslag for produkter.",
    documentType: "Dokumenttype",
    selectDocumentType: "Velg dokumenttype...",
    none: "Ingen",
    market: "Marked",
    anyMarket: "Alle markeder",
    marketHelpText: 'La stå som "Alle" for å matche første tilgjengelige',
    cancel: "Avbryt",
    save: "Lagre",
    failedToSave: "Kunne ikke lagre dokumenttype",
  },
} as const;
